export const ACCOUNT_MANAGEMENT = Object.freeze({
  menuItems: [
    {
      name: 'Profile Information',
      icon: 'account_circle',
      link: 'account_management_profile',
      expanded: false,
    },
    {
      name: 'Account Settings',
      icon: 'settings',
      link: 'account_management_settings',
      expanded: true,
      items: [
        { name: 'Connections', hash: '#connections' },
        { name: 'Notifications', hash: '#notifications' },
        { name: 'Task Categories', hash: '#task-categories' },
      ],
    },
    {
      name: 'Contacts',
      icon: 'group',
      link: 'account_management_contacts',
      expanded: true,
      items: [
        { name: 'Import/Export', hash: '#import-export' },
        { name: 'Duplicates', hash: '#duplicates' },
        { name: 'Custom Fields', hash: '#custom-fields' },
        { name: 'Hotness', hash: '#hotness' },
        { name: 'Tags', hash: '#tags' },
        { name: 'Relationship Types', hash: '#relationship-types' },
      ],
    },
    { name: 'Teams', icon: 'groups', link: 'account_management_teams', expanded: false },
    {
      name: 'Lead Routing & Rules',
      icon: 'group',
      link: 'account_management_lead_routing',
      expanded: true,
      items: [
        { name: 'Lead Routes', hash: '#lead-routes' },
        { name: 'Lead Sources', hash: '#lead-sources' },
      ],
    },
    {
      name: 'Subaccount Management',
      icon: '$vuetify.icons.sitemap',
      link: 'account_management_subaccount',
      expanded: false,
    },
    {
      name: 'Addons',
      icon: '$vuetify.icons.addon',
      link: 'account_management_addons',
      expanded: false,
    },
    {
      name: 'Integrations',
      icon: 'extension',
      link: 'account_management_integrations',
      expanded: true,
      items: [
        { name: 'Marketplace', hash: '#marketplace' },
        { name: 'Featured Integrators', hash: '#featured-integrators' },
        { name: '3rd Party Services', hash: '#3rd-party' },
      ],
    },
    {
      name: 'Billing & Limits',
      icon: '$vuetify.icons.credit-card-inverse',
      link: 'account_management_billing',
      expanded: false,
    },
  ],
});

export const ACCOUNT_SETTINGS = Object.freeze({
  taskCategories: {
    headers: [
      { text: 'Order', value: 'rank' },
      { text: 'Name', value: 'name' },
      { text: 'Color', value: 'color' },
    ],
    singularResource: 'Task Category',
    pluralResources: 'Task Categories',
    placeHolderItem: { id: 0, name: 'Type New Category', rank: 1, color: '#FFFFFF' },
    hash: 'task-categories',
    title: 'Task Categories',
    resourceType: 'DefaultType',
  },
});

export const CONTACTS = Object.freeze({
  customFields: {
    headers: [
      { text: 'Order', value: 'rank' },
      { text: 'Custom Field', value: 'name' },
      { text: 'Value', value: 'data_type' },
      { text: 'Times Used', value: 'use_count' },
    ],
    singularResource: 'Custom Field',
    pluralResources: 'Custom Fields',
    placeHolderItem: { id: 0, name: 'New Custom field', data_type: 'Text', use_count: 0, rank: 1 },
    hash: 'custom-fields',
    title: 'Custom Fields',
    resourceType: 'CustomFields',
  },
  hotness: {
    headers: [
      { text: 'Order', value: 'rank' },
      { text: 'Hotness Level', value: 'name' },
      { text: 'Color', value: 'color' },
    ],
    singularResource: 'Hotness Level',
    pluralResources: 'Hotness Levels',
    placeHolderItem: { id: 0, name: 'New Hotness', color: '#008000', rank: 1 },
    hash: 'hotness',
    title: 'Hotness',
    resourceType: 'Hotness',
  },
  tags: {
    headers: [{ text: 'Tag Name', value: 'content' }],
    singularResource: 'Tag',
    pluralResources: 'Tags',
    placeHolderItem: { id: 0, content: 'New Tag' },
    hash: 'tags',
    title: 'Tags',
    resourceType: 'ContactTags',
  },
  relationshipTypes: {
    hash: 'relationship-types',
    title: 'Relationship Types',
    resourceType: 'ContactTypes',
    singularResource: 'Relationship',
    pluralResource: 'Relationships',
    placeHolderItem: { id: 0, name: 'New Relationship' },
    headers: [{ text: 'Relationship', value: 'name' }],
  },
});

export const TEAMS = Object.freeze({
  teams: {
    data: [
      { name: 'Ivan Hernandez(iolmos@lwolf.com)', type: '' },
      { name: 'Saian Ford (sford@lwolf.com)', type: 'Distribution Rules', icon: 'notes' },
    ],
  },
});

export const INTEGRATIONS = Object.freeze({
  marketplace: {
    cma: {
      features: [
        { text: 'Create beautiful reports at a click of a button and win more listings.' },
        { text: 'Auto-populate properly address to eliminate double entry.' },
        { text: "Track all CMAs you've generated for a contact in activity timeline." },
      ],
      textButton: 'Connect Cloud CMA to LionDesk',
    },
    zipForm: {
      features: [
        {
          text:
            'Start transactions from a contact profile and automatically create the transaction in ZipForm.',
        },
        {
          text: 'Pre-fill contact details in a transaction - save time and eliminate double-entry.',
        },
        { text: 'Track transactions in the activity timeline.' },
      ],
      textButton: 'Connect zipForm to LionDesk',
    },
    transactionDesk: {
      features: [
        {
          text:
            'Start transactions from a contact profile and automatically create the transaction in TransactionDesk.',
        },
        {
          text: 'Pre-fill contact details in a transaction - save time and eliminate double-entry.',
        },
        { text: 'Track transactions in the activity timeline.' },
      ],
      textButton: 'Connect TransactionDesk to LionDesk',
    },
  },
  integrators: {
    mojo: {
      id: 'mojo',
      features: [
        { text: 'Sync contacts from Mojo to LionDesk' },
        { text: 'Select a grouo you want to sync, or sync all the contacts.' },
        { text: 'Track and sync LionDesk task back to Mojo contacts.' },
        { text: 'Import/track you call notes from Mojo to LionDesk' },
      ],
      textButton: 'Learn more about Mojo',
      redirectUrl: 'https://my.apination.com/liondesk/mojo/1',
      logo: '/static/img/mojo_logo.png',
    },
    brokerMint: {
      id: 'brokerMint',
      features: [
        {
          text:
            'Real Estate back office Management for Brokers.\nTransaction Management and Commission Tracking.',
        },
        { text: 'Get real-time analytics and repors on all the metrics that matter.' },
      ],
      textButton: 'Connect BrokerMint to LionDesk',
      redirectUrl: 'https://my.apination.com/apps/liondesk/brokermint/',
      logo: '/static/img/brokermint_logo.png',
    },
    boxBrownie: {
      id: 'boxBrownie',
      features: [
        { text: 'Professional high quality photo editing' },
        { text: 'Image Enhancement, Virtual Staging and more.' },
        { text: 'LionDesk members receive a $20 credit. Get started today.' },
      ],
      textButton: 'Start now with BoxBrownie and save $20',
      redirectUrl: 'https://www.boxbrownie.com/?ts=lndsk',
      logo: '/static/img/boxbromnie_logo.png',
    },
    callAction: {
      id: 'callAction',
      features: [
        {
          text:
            'CallAction is a marketing automation platform that can be used with your offline or online lead generation efforts to respond to inquiries from the three primary forms of communication: phone calls, emails and text messages.',
        },
      ],
      textButton: 'Learn more about CallAction',
      redirectUrl: 'https://help.callaction.co/en/articles/1485825-liondesk',
      logo: '/static/img/callaction_logo.png',
    },
    googleSheet: {
      id: 'googleSheet',
      features: [
        {
          text:
            'Sync your Contacts in LionDesk to a Google Sheet.\nTarget all your contacts or contacts with a specific tag.',
        },
        {
          text:
            'Easy Create reports and graphs in Google Sheets using your LionDesk contact data.\nSave time and errros importing and mass updating customers by simply editing right on your synced Google Sheet',
        },
      ],
      textButton: 'Learn more about Google Sheets',
      redirectUrl: 'https://my.apination.com/liondesk/google_sheets/1',
      logo: '/static/img/googlesheet_logo.png',
    },
  },
  vendorServices: {
    headers: [
      { text: 'Service', value: 'service' },
      { text: 'Key', value: 'key' },
      { text: 'Actions', value: 'actions', align: 'right' },
    ],
    data: [
      { service: 'Agent Evolution IDX', key: '' },
      { service: 'AgentFire', key: '' },
      { service: 'Easy Agent Pro', key: '' },
      { service: 'Leadpops', key: '' },
      { service: 'ListingToLeads', key: '' },
      { service: 'MyPlusLeads', key: '' },
      { service: 'Personal', key: '' },
      { service: 'Ylopo IDX', key: 'somekey' },
      { service: 'Zapier', key: 'somekey2' },
      { service: 'A2A', key: '' },
    ],
  },
});

export const ADDONS = Object.freeze({
  powerDialer: {
    headers: [
      { text: 'Power Dialer Disposition', value: 'categories' },
      { text: 'Actions', value: 'actions', align: 'right' },
    ],
    data: [
      { category: 'Voicemail - No Message' },
      { category: 'No Answer' },
      { category: 'Busy' },
      { category: 'Voucemauk - Left Message' },
      { category: 'Follow Up' },
      { category: 'Set Appointment' },
      { category: 'Bad Contact Info' },
    ],
  },
  addons: {
    landingPages: {
      text:
        'Creating beautiful, higg converting landing pages directly connected to your LionDesk database',
      textButton: 'Get Started',
    },
    leadPlus: {
      text: 'Get more leads and win more deals with done-for-you digital marketing.',
      textButton: 'Take me to leads+',
    },
    multiLineDialer: {
      text:
        'All benefits from single dialer, callback message and call up to 3 lines simultaneously',
      textButton: 'Upgrade',
    },
  },
});

export const LEAD_ROUTING = Object.freeze({
  leadRoutes: {
    headers: [
      { text: 'Lead Type', value: 'lead_source' },
      { text: 'Source Added', value: 'contact_source' },
      { text: 'Drip Campaign', value: 'campaign' },
      { text: 'Distribution', value: 'distribution_target' },
    ],
    singularResource: 'Lead Route',
    pluralResources: 'Lead Routes',
    placeHolderItem: {
      id: 0,
      lead_source_name: 'New Lead Route',
      contact_source_name: 'New Source',
      campaign_name: 'New Drip Campaign',
      distribution_target_name: 'New Distribution',
    },
    hash: 'lead-routes',
    title: 'Lead Routes',
    resourceType: 'LeadRoutes',
  },
  leadSources: {
    headers: [{ text: 'Source', value: 'name', filterable: true }],
    singularResource: 'Source',
    pluralResources: 'Sources',
    placeHolderItem: { id: 0, name: 'New Lead Source' },
    hash: 'lead-sources',
    title: 'Lead Sources',
    resourceType: 'LeadSources',
  },
});

export const BILLING = Object.freeze({
  activeServices: {
    headers: [
      { text: 'Services', value: 'services' },
      { text: 'Status', value: 'status' },
      { text: 'Active Until', value: 'active_until' },
      { text: 'Next Billing Date', value: 'next_billing_date' },
    ],
    data: [
      {
        service: 'Single Line Dialer',
        status: 'Active',
        active_until: '12/28/22',
        next_billing_date: '12/29/22',
      },
      {
        service: 'Landing Pages',
        status: 'Active',
        active_until: '12/28/22',
        next_billing_date: '12/29/22',
      },
    ],
  },
  recentTransactions: {
    headers: [
      { text: 'Date', value: 'date' },
      { text: 'Amount', value: 'amount' },
    ],
    data: [
      { date: '11/28/22', amount: '$99.00' },
      { date: '11/28/22', amount: '$29.00' },
    ],
  },
  limits: {
    email: {
      title: 'Email Remaining (Monthly)',
      usage: '14,983 (98%)',
      percent: 80,
    },
    text: {
      title: 'Texts Remaining (Monthly)',
      usage: '14,983 (98%)',
      percent: 80,
    },
    video: {
      title: 'Video Remaining (Monthly)',
      usage: '14,983 (98%)',
      percent: 80,
    },
  },
});

export const TIMEZONES = [
  { value: 'America/New_York', text: 'America - Eastern' },
  { value: 'America/Chicago', text: 'America - Central' },
  { value: 'America/Denver', text: 'America - Mountain (Denver)' },
  { value: 'America/Phoenix', text: 'America - Mountain no DST (Phoenix)' },
  { value: 'America/Los_Angeles', text: 'America - Pacific' },
  { value: 'America/Anchorage', text: 'America - Alaska' },
  { value: 'Pacific/Honolulu', text: 'Hawaii no DST (Honolulu)' },
  { value: 'America/Adak', text: 'Hawaii (Aleutian)' },
  { value: 'UTC', text: 'UTC (+00:00)' },
  { value: 'Europe/Amsterdam', text: '(GMT+01:00) Amsterdam' },
  { value: 'Europe/Belgrade', text: '(GMT+01:00) Belgrade' },
  { value: 'Europe/Berlin', text: '(GMT+01:00) Berlin' },
  { value: 'Europe/Bratislava', text: '(GMT+01:00) Bratislava' },
  { value: 'Europe/Brussels', text: '(GMT+01:00) Brussels' },
  { value: 'Europe/Budapest', text: '(GMT+01:00) Budapest' },
  { value: 'Europe/Copenhagen', text: '(GMT+01:00) Copenhagen' },
  { value: 'Europe/Ljubljana', text: '(GMT+01:00) Ljubljana' },
  { value: 'Europe/Madrid', text: '(GMT+01:00) Madrid' },
  { value: 'Europe/Paris', text: '(GMT+01:00) Paris' },
  { value: 'Europe/Prague', text: '(GMT+01:00) Prague' },
  { value: 'Europe/Rome', text: '(GMT+01:00) Rome' },
  { value: 'Europe/Sarajevo', text: '(GMT+01:00) Sarajevo' },
  { value: 'Europe/Skopje', text: '(GMT+01:00) Skopje' },
  { value: 'Europe/Stockholm', text: '(GMT+01:00) Stockholm' },
  { value: 'Europe/Vienna', text: '(GMT+01:00) Vienna' },
  { value: 'Europe/Warsaw', text: '(GMT+01:00) Warsaw' },
  { value: 'Europe/Zagreb', text: '(GMT+01:00) Zagreb' },
  { value: 'Europe/Athens', text: '(GMT+02:00) Athens' },
  { value: 'Europe/Bucharest', text: '(GMT+02:00) Bucharest' },
  { value: 'Africa/Cairo', text: '(GMT+02:00) Cairo' },
  { value: 'Africa/Harare', text: '(GMT+02:00) Harare' },
  { value: 'Europe/Helsinki', text: '(GMT+02:00) Helsinki' },
  { value: 'Europe/Istanbul', text: '(GMT+02:00) Istanbul' },
  { value: 'Asia/Jerusalem', text: '(GMT+02:00) Jerusalem' },
  { value: 'Europe/Kiev', text: '(GMT+02:00) Kyiv' },
  { value: 'Europe/Minsk', text: '(GMT+02:00) Minsk' },
  { value: 'Europe/Riga', text: '(GMT+02:00) Riga' },
  { value: 'Europe/Sofia', text: '(GMT+02:00) Sofia' },
  { value: 'Europe/Tallinn', text: '(GMT+02:00) Tallinn' },
  { value: 'Europe/Vilnius', text: '(GMT+02:00) Vilnius' },
  { value: 'Asia/Baghdad', text: '(GMT+03:00) Baghdad' },
  { value: 'Asia/Kuwait', text: '(GMT+03:00) Kuwait' },
  { value: 'Africa/Nairobi', text: '(GMT+03:00) Nairobi' },
  { value: 'Asia/Riyadh', text: '(GMT+03:00) Riyadh' },
  { value: 'Europe/Moscow', text: '(GMT+03:00) Moscow' },
  { value: 'Asia/Tehran', text: '(GMT+03:30) Tehran' },
  { value: 'Asia/Baku', text: '(GMT+04:00) Baku' },
  { value: 'Europe/Volgograd', text: '(GMT+04:00) Volgograd' },
  { value: 'Asia/Muscat', text: '(GMT+04:00) Muscat' },
  { value: 'Asia/Tbilisi', text: '(GMT+04:00) Tbilisi' },
  { value: 'Asia/Yerevan', text: '(GMT+04:00) Yerevan' },
  { value: 'Asia/Kabul', text: '(GMT+04:30) Kabul' },
  { value: 'Asia/Karachi', text: '(GMT+05:00) Karachi' },
  { value: 'Asia/Tashkent', text: '(GMT+05:00) Tashkent' },
  { value: 'Asia/Kolkata', text: '(GMT+05:30) Kolkata' },
  { value: 'Asia/Kathmandu', text: '(GMT+05:45) Kathmandu' },
  { value: 'Asia/Yekaterinburg', text: '(GMT+06:00) Ekaterinburg' },
  { value: 'Asia/Almaty', text: '(GMT+06:00) Almaty' },
  { value: 'Asia/Dhaka', text: '(GMT+06:00) Dhaka' },
  { value: 'Asia/Novosibirsk', text: '(GMT+07:00) Novosibirsk' },
  { value: 'Asia/Bangkok', text: '(GMT+07:00) Bangkok' },
  { value: 'Asia/Jakarta', text: '(GMT+07:00) Jakarta' },
  { value: 'Asia/Krasnoyarsk', text: '(GMT+08:00) Krasnoyarsk' },
  { value: 'Asia/Chongqing', text: '(GMT+08:00) Chongqing' },
  { value: 'Asia/Hong_Kong', text: '(GMT+08:00) Hong Kong' },
  { value: 'Asia/Kuala_Lumpur', text: '(GMT+08:00) Kuala Lumpur' },
  { value: 'Australia/Perth', text: '(GMT+08:00) Perth' },
  { value: 'Asia/Singapore', text: '(GMT+08:00) Singapore' },
  { value: 'Asia/Taipei', text: '(GMT+08:00) Taipei' },
  { value: 'Asia/Ulaanbaatar', text: '(GMT+08:00) Ulaan Bataar' },
  { value: 'Asia/Urumqi', text: '(GMT+08:00) Urumqi' },
  { value: 'Asia/Irkutsk', text: '(GMT+09:00) Irkutsk' },
  { value: 'Asia/Seoul', text: '(GMT+09:00) Seoul' },
  { value: 'Asia/Tokyo', text: '(GMT+09:00) Tokyo' },
  { value: 'Australia/Adelaide', text: '(GMT+09:30) Adelaide' },
  { value: 'Australia/Darwin', text: '(GMT+09:30) Darwin' },
  { value: 'Asia/Yakutsk', text: '(GMT+10:00) Yakutsk' },
  { value: 'Australia/Brisbane', text: '(GMT+10:00) Brisbane' },
  { value: 'Australia/Canberra', text: '(GMT+10:00) Canberra' },
  { value: 'Pacific/Guam', text: '(GMT+10:00) Guam' },
  { value: 'Australia/Hobart', text: '(GMT+10:00) Hobart' },
  { value: 'Australia/Melbourne', text: '(GMT+10:00) Melbourne' },
  { value: 'Pacific/Port_Moresby', text: '(GMT+10:00) Port Moresby' },
  { value: 'Australia/Sydney', text: '(GMT+10:00) Sydney' },
  { value: 'Asia/Vladivostok', text: '(GMT+11:00) Vladivostok' },
  { value: 'Asia/Magadan', text: '(GMT+12:00) Magadan' },
  { value: 'Pacific/Auckland', text: '(GMT+12:00) Auckland' },
  { value: 'Pacific/Fiji', text: '(GMT+12:00) Fiji' },
];

export const COUNTRIES = [
  { value: 'US', text: 'United States' },
  { value: 'CA', text: 'Canada' },
];
